var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIndustryIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 18,
    fill: "#F4F4F4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 26H11M11 26V17C11 15.8954 11.8954 15 13 15H18M11 26H18M18 15V11C18 9.89543 18.8954 9 20 9H23C24.1046 9 25 9.89543 25 11V26M18 15V26M18 26H21.5M25 26H27M25 26H21.5M21.5 26V22M20.5 12H22.5M20.5 15H22.5M20.5 18H22.5M13.5 18H15.5M13.5 20.5H15.5",
    stroke: "#09041C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndustryIcon);
export default __webpack_public_path__ + "static/media/industry-icon.fdc243b05749f80f9d6876cc8fab5057.svg";
export { ForwardRef as ReactComponent };